interface ContextActionBase {
  id: number | string
  label: string
  testId?: string
  internalAdminOnly?: true
  isExternal?: boolean
}
interface ContextActionSubmenu extends ContextActionBase {
  subactions: Submenu
}
interface ContextActionFunction extends ContextActionBase {
  call(): void
}
export type ContextAction = ContextActionFunction | ContextActionSubmenu

export interface ContextMenu {
  show: boolean
  options: ContextAction[]
  context: any
  origin: null | { x: number; y: number }
}

type Submenu = {
  returnLabel: string
  actions: ContextAction[]
}

const defaultOptions: ContextMenu = {
  show: false,
  options: [],
  context: null,
  origin: null,
}

export function useContextMenu() {
  const contextMenu = ref<ContextMenu>({ ...defaultOptions })

  function open(menuOptions: { event: MouseEvent; context: any; options: ContextAction[] } | null) {
    if (!menuOptions) {
      contextMenu.value = { ...defaultOptions }
      return
    }

    contextMenu.value = {
      show: true,
      context: menuOptions.context,
      options: menuOptions.options,
      origin: { x: menuOptions.event.clientX, y: menuOptions.event.clientY },
    }
  }

  function close() {
    contextMenu.value = { ...contextMenu.value, show: false }
  }

  return { contextMenu: readonly(contextMenu), open, close }
}
